import { useState } from "react";
import { Menu, X, Wrench, Phone } from "lucide-react";
import { BUSINESS } from "@/data/site";

const LINKS = [
  { label: "Services", href: "#services", testId: "nav-link-services" },
  { label: "Why Us", href: "#why-us", testId: "nav-link-why-us" },
  { label: "Price Guide", href: "#price-guide", testId: "nav-link-price-guide" },
  { label: "Contact", href: "#quote", testId: "nav-link-contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-zinc-800 bg-zinc-950/95 backdrop-blur-sm" data-testid="navbar">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-8">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-logo">
          <span className="flex h-9 w-9 items-center justify-center bg-orange-600 text-white">
            <Wrench className="h-5 w-5" />
          </span>
          <span className="font-display text-lg font-extrabold uppercase tracking-tight text-white">
            {BUSINESS.name}
          </span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-links">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testId}
              className="text-sm font-bold uppercase tracking-wider text-zinc-400 transition-colors duration-150 hover:text-orange-500"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#quote"
            data-testid="nav-quote-button"
            className="border border-orange-600 bg-orange-600 px-6 py-2.5 text-sm font-bold uppercase tracking-wider text-white transition-colors duration-150 hover:bg-orange-500"
          >
            Get Free Quote
          </a>
        </nav>

        <button
          className="text-white lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav className="border-t border-zinc-800 bg-zinc-950 px-6 py-4 lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`${l.testId}-mobile`}
                className="text-sm font-bold uppercase tracking-wider text-zinc-300 hover:text-orange-500"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#quote"
              onClick={() => setOpen(false)}
              data-testid="nav-quote-button-mobile"
              className="mt-2 flex items-center justify-center gap-2 border border-orange-600 bg-orange-600 px-6 py-3 text-sm font-bold uppercase tracking-wider text-white"
            >
              <Phone className="h-4 w-4" /> Get Free Quote
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}
